import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGUAGES, type Language } from '../i18n'
import { buildDemoData, type DemoData } from './demoData'

function currentLanguage(resolved: string | undefined): Language {
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(resolved ?? '')
    ? (resolved as Language)
    : 'en'
}

/**
 * Demo fixtures for the active UI language. Every consumer (desktop demo and
 * mobile app) reads its data through this hook so names, exam titles and
 * feedback follow the language switcher.
 */
export function useDemoData(): DemoData {
  const { i18n } = useTranslation()
  const lang = currentLanguage(i18n.resolvedLanguage)
  return useMemo(() => buildDemoData(lang), [lang])
}
